import { isFunction } from "./assertions";
export function assignRef(ref, value) {
    if (ref == null)
        return;
    if (isFunction(ref)) {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    }
    catch (error) {
        throw new Error("Cannot assign value '".concat(value, "' to ref '").concat(ref, "'"));
    }
}
export function mergeRefs() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return function (node) {
        refs.forEach(function (ref) { return assignRef(ref, node); });
    };
}
